
export enum LogSeverity {
    JL1,
    JL2,
    JL3,
    JL4,
    JL5,
}
